'use strict';
import moment from 'moment';

// Regras do encerramento das atividades da Zetaone (ver ShutdownNotice.jsx).

// Último mês de vencimento aceito em novos envios: outubro/2026, porque as
// cobranças enviadas podem ser pagas até 31/10/2026. A partir de novembro/2026
// o vencimento fica desabilitado no seletor.
export const LAST_INVOICE_MONTH = '2026-10';

// A partir desta data o envio de novas cobranças fica suspenso.
export const SEND_SUSPENDED_FROM = '2026-10-01';

export const getLastInvoiceMonth = () =>
  moment(LAST_INVOICE_MONTH, 'YYYY-MM').endOf('month');

export const isSendSuspended = () =>
  moment().isSameOrAfter(moment(SEND_SUSPENDED_FROM, 'YYYY-MM-DD'), 'day');

export const SEND_SUSPENDED_MESSAGE =
  'O envio de novas cobranças foi suspenso em 01/10/2026, em razão do encerramento das atividades da Zetaone.';

// Recorrência e parcelamento ficam indisponíveis no encerramento: planos de
// faturas não cabem no prazo restante, que vai só até 31/10/2026.
export const IS_RECURRING_AVAILABLE = false;
